import { SVGProps } from 'react';

export const Stars = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox='0 0 16 17' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M6.54213 11.1025L6 13L5.45787 11.1025C5.17312 10.1059 4.39408 9.32688 3.39746 9.04213L1.5 8.5L3.39746 7.95787C4.39408 7.67312 5.17312 6.89408 5.45787 5.89746L6 4L6.54213 5.89746C6.82688 6.89408 7.60592 7.67312 8.60254 7.95787L10.5 8.5L8.60254 9.04213C7.60592 9.32688 6.82688 10.1059 6.54213 11.1025Z'
        stroke='url(#paint0_linear_5796_354843)'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M12.1726 6.30969L12 7L11.8274 6.30969C11.6259 5.50355 10.9964 4.87411 10.1903 4.67258L9.5 4.5L10.1903 4.32742C10.9964 4.12589 11.6259 3.49645 11.8274 2.69031L12 2L12.1726 2.69031C12.3741 3.49645 13.0036 4.12589 13.8097 4.32742L14.5 4.5L13.8097 4.67258C13.0036 4.87411 12.3741 5.50355 12.1726 6.30969Z'
        stroke='url(#paint1_linear_5796_354843)'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M11.2628 14.2115L11 15L10.7372 14.2115C10.5879 13.7636 10.2364 13.4121 9.78849 13.2628L9 13L9.78849 12.7372C10.2364 12.5879 10.5879 12.2364 10.7372 11.7885L11 11L11.2628 11.7885C11.4121 12.2364 11.7636 12.5879 12.2115 12.7372L13 13L12.2115 13.2628C11.7636 13.4121 11.4121 13.7636 11.2628 14.2115Z'
        stroke='url(#paint2_linear_5796_354843)'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <defs>
        <linearGradient
          id='paint0_linear_5796_354843'
          x1='0.98'
          y1='5.00001'
          x2='16.2683'
          y2='5.05921'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#54B5D3' />
          <stop offset='0.979167' stopColor='#2132A0' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_5796_354843'
          x1='0.98'
          y1='5.00001'
          x2='16.2683'
          y2='5.05921'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#54B5D3' />
          <stop offset='0.979167' stopColor='#2132A0' />
        </linearGradient>
        <linearGradient
          id='paint2_linear_5796_354843'
          x1='0.98'
          y1='5.00001'
          x2='16.2683'
          y2='5.05921'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#54B5D3' />
          <stop offset='0.979167' stopColor='#2132A0' />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const StarsWhite = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    {...props}>
    <path
      d='M6.54213 10.6025L6 12.5L5.45787 10.6025C5.17312 9.60592 4.39408 8.82688 3.39746 8.54213L1.5 8L3.39746 7.45787C4.39408 7.17312 5.17312 6.39408 5.45787 5.39746L6 3.5L6.54213 5.39746C6.82688 6.39408 7.60592 7.17312 8.60254 7.45787L10.5 8L8.60254 8.54213C7.60592 8.82688 6.82688 9.60592 6.54213 10.6025Z'
      stroke='white'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M12.1726 5.80969L12 6.5L11.8274 5.80969C11.6259 5.00355 10.9964 4.37411 10.1903 4.17258L9.5 4L10.1903 3.82742C10.9964 3.62589 11.6259 2.99645 11.8274 2.19031L12 1.5L12.1726 2.19031C12.3741 2.99645 13.0036 3.62589 13.8097 3.82742L14.5 4L13.8097 4.17258C13.0036 4.37411 12.3741 5.00355 12.1726 5.80969Z'
      stroke='white'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M11.2628 13.7115L11 14.5L10.7372 13.7115C10.5879 13.2636 10.2364 12.9121 9.78849 12.7628L9 12.5L9.78849 12.2372C10.2364 12.0879 10.5879 11.7364 10.7372 11.2885L11 10.5L11.2628 11.2885C11.4121 11.7364 11.7636 12.0879 12.2115 12.2372L13 12.5L12.2115 12.7628C11.7636 12.9121 11.4121 13.2636 11.2628 13.7115Z'
      stroke='white'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
